<template>
  <el-dialog
    title="Изменение вопроса"
    :visible.sync="$store.getters.faqUpdateDialog"
    width="60%"
    :before-close="handleClose"
  >
    <el-form>
      <el-form-item label="Вопрос">
        <el-input class="question-form__textarea question-form__textarea--question" type="textarea" v-model="question.question"></el-input>
      </el-form-item>
      <el-form-item label="Ответ">
        <el-input class="question-form__textarea question-form__textarea--answer" type="textarea" v-model="question.answer"></el-input>
      </el-form-item>
      <el-form-item label="Сортировка">
        <el-input v-model="question.sort"></el-input>
      </el-form-item>
      <el-form-item label="Активность">
        <el-checkbox v-model="question.activity"></el-checkbox>
      </el-form-item>
      <el-form-item label="Перенести в другой раздел">
        <el-select v-model="question.section" filterable placeholder="Select">
          <el-option
            v-for="item in sections"
            :key="item.id"
            :label="item.title"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="$store.commit('faqUpdateDialog', false)"
        >Отмена</el-button
      >
      <el-button
        type="primary"
        :disabled="disableButton"
        @click="(e) => saveFAQ(e)"
        >Изменить</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import axios from "axios";
import { SETPRELOADER_STATE } from "@/store/mutation-types";
import getErrors, { getTextErrors } from '../../composable/utils/getErrors';

export default {
  name: "CreatePriceTypeDialog",
  props: {
    updateQuestion: {
      type: Boolean,
    },
    question: {
      type: Object,
    },
    sectionId: {
      type: Number,
      default: 0
    }
  },
  data: function () {
    return {
      form: {
        question: "",
        answer: "",
        section: "",
        sort: "",
        activity: true,
      },
      sections: [],
      status: 0,
    };
  },
  computed: {
    disableButton() {
      return this.question.answer === "" || this.question.question === "";
    },
  },
  watch: {
    updateQuestion(isUpdated) {
      if (isUpdated) {
        const id =
          this.$store.getters.faqSectionId.id ||
          this.$store.getters.faqSectionId;

        this.getFAQ(id);
        this.$emit("update-question", !this.updateQuestion);
      }
    },
  },
  mounted() {
    this.getSections()
  }, 
  methods: {
    getSections: function () {
      axios
        .get("/faq/section/")
        .then((response) => {
          this.sections = response.data.data;
          this.paginator = response.data.meta;
        })
        .catch((errors) => {
          if (errors.response.status === 401) {
            this.$router.push("/login");
          }
        });
    },
    handleClose() {
      this.$store.commit("faqUpdateDialog", false);
    },
    getTarget(e) {
      const t = e.target;

      return t.classList.contains("el-button") ? t : t.parentNode;
    },
    saveFAQ(e) {
      let data = {
        answer: this.question.answer,
        question: this.question.question,
        section: this.question.section,
        sort: this.question.sort,
        activity: this.question.activity,
      };

        const id =
          this.$store.getters.faqSectionId?.id ||
          this.$store.getters.faqSectionId;

      const btn = this.getTarget(e);

      btn.style.pointerEvents = "none";

      const loader = setTimeout(() => {
        this.$store.commit(SETPRELOADER_STATE, true);
      }, 400);

      axios
        .post("/faq/question/" +  id , data)
        .then((response) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);
          btn.style.pointerEvents = "all";

          this.status = response.status;
          this.$store.commit("faqUpdateDialog", false);
          this.question.answer = "";
          this.question.question = "";
          this.$emit("question-redacted");
        })
        .catch((errors) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);
          btn.style.pointerEvents = "all";

          if (errors.response.status === 401) {
            this.$router.push("/login");
          }

          if(errors.response.status === 422) {
            this.$notify.error(getTextErrors(getErrors(errors.response.data.errors)))
          }
        });
    },
  },
};
</script>

<style lang="scss">
.question-form {
  &__textarea {

    &--question {
      textarea {
        height: 50px;
      }
    }

    &--answer {

      textarea {
        height: 100px;
      }
    }

    textarea {
      resize: none;
    }
  }
}
</style>